import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import Filter from 'components/commons/filter'
import { deepClone } from 'utils/utils'
import { API_DEVELOPMENT_SUMMARY } from 'services/apiDevelopmentSummary'

export const OPTIONS_NINE_BOX_LABEL = [
    { id: 'Falling Star', name: 'Falling Star' },
    { id: 'Aspiring Star', name: 'Aspiring Star' },
    { id: 'Bright Star', name: 'Bright Star' },
    { id: 'Emerging Star', name: 'Emerging Star' },
    { id: 'Promising Star', name: 'Promising Star' },
    { id: 'Super Star', name: 'Super Star' },
    { id: 'Rock Star', name: 'Rock Star' },
    { id: 'Rising Star', name: 'Rising Star' },
    { id: 'Mega Star', name: 'Mega Star' },
]

export const OPTIONS_POTENTIAL_CATEGORY = [
    { id: 'low', name: 'Low' },
    { id: 'moderate', name: 'Moderate' },
    { id: 'high', name: 'High' },
]

export const OPTIONS_PERFORMANCE_CATEGORY = [
    { id: 'low', name: 'Low' },
    { id: 'moderate', name: 'Moderate' },
    { id: 'high', name: 'High' },
]

export const OPTIONS_THREE_SIXTY_CATEGORY = [
    { id: 'Below Expectation', name: 'Below Expectation' },
    { id: 'Near Expectation', name: 'Near Expectation' },
    { id: 'Meet Expectation', name: 'Meet Expectation' },
]

const FILTER = {
    DEPARTMENT: 'departments',
    DIVISION: 'divisions',
    THREE_SIXTY_CATEGORIES: 'three_sixty_categories',
    PERFORMANCE_CATEGORIES: 'performance_categories',
    POTENTIAL_CATEGORIES: 'potential_categories',
    NINE_BOX_LABELS: 'nine_box_labels',
}

const QUERY_PARAMS = {
    [FILTER.DEPARTMENT]: 'department_ids',
    [FILTER.DIVISION]: 'division_ids',
    [FILTER.THREE_SIXTY_CATEGORIES]: 'three_sixty_categories',
    [FILTER.PERFORMANCE_CATEGORIES]: 'performance_categories',
    [FILTER.POTENTIAL_CATEGORIES]: 'potential_categories',
    [FILTER.NINE_BOX_LABELS]: 'nine_box_labels',
}

const INITIAL_DATA_FILTER = [
    { label: 'Department', value: FILTER.DEPARTMENT },
    { label: 'Divisi', value: FILTER.DIVISION },
    { label: '360 Category', value: FILTER.THREE_SIXTY_CATEGORIES },
    { label: 'Performance Category', value: FILTER.PERFORMANCE_CATEGORIES },
    { label: 'Potential Category', value: FILTER.POTENTIAL_CATEGORIES },
    { label: 'Nine Box Label', value: FILTER.NINE_BOX_LABELS },
]

const INITIAL_FILTER = {
    department_ids: [],
    division_ids: [],
    three_sixty_categories: [],
    performance_categories: [],
    potential_categories: [],
    nine_box_labels: [],
}

export const DevelopmentSummaryFilterContainer = ({ onSubmit, queryFilter }) => {
    const [show, setShow] = useState(false)
    const [activeFilter, setActiveFilter] = useState(INITIAL_DATA_FILTER[0])
    const [filter, setFilter] = useState(INITIAL_FILTER)
    const [filterCount, setFilterCount] = useState()
    const [errorFilter, setErrorFilter] = useState({})
    const [options, setOptions] = useState()

    const { fetching: getDepartmentList } = useFetch(API_DEVELOPMENT_SUMMARY.LIST_DEPARTMENT, {}, { isFetching: true })
    const { fetching: getDivisionList } = useFetch(API_DEVELOPMENT_SUMMARY.LIST_DIVISION, {}, { isFetching: true })

    useEffect(() => {
        ;(async () => {
            const [departmentList, divisionList] = await Promise.all([getDepartmentList(), getDivisionList()])

            setOptions({
                [FILTER.DEPARTMENT]: departmentList?.data,
                [FILTER.DIVISION]: divisionList?.data,
                [FILTER.THREE_SIXTY_CATEGORIES]: OPTIONS_THREE_SIXTY_CATEGORY,
                [FILTER.PERFORMANCE_CATEGORIES]: OPTIONS_PERFORMANCE_CATEGORY,
                [FILTER.POTENTIAL_CATEGORIES]: OPTIONS_POTENTIAL_CATEGORY,
                [FILTER.NINE_BOX_LABELS]: OPTIONS_NINE_BOX_LABEL,
            })
        })()
    }, [])

    useEffect(() => {
        if (queryFilter) {
            const newQueryFilter = deepClone(queryFilter)
            setFilter(newQueryFilter)
            countFilterLength(newQueryFilter)
        }
    }, [queryFilter])

    const onCloseHandler = () => {
        setShow(false)
        setErrorFilter({})
    }

    const onSelectFilter = (item) => {
        setActiveFilter(item)
    }

    const onChangeOption = (item) => {
        const { name, value, checked } = item
        const arrChecked = filter?.[QUERY_PARAMS[name]] || []

        if (checked) {
            arrChecked.push(String(value))
        } else {
            const indexRemove = arrChecked.indexOf(String(value))
            arrChecked.splice(indexRemove, 1)
        }
        setFilter({ ...filter, [QUERY_PARAMS[name]]: arrChecked })
    }

    const validateFilter = (query) => {
        return new Promise((resolve, reject) => {
            const errors = {}
            setErrorFilter(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmitFilter = () => {
        const queryFilter = { ...filter }
        validateFilter(queryFilter).then(() => {
            Object.entries(queryFilter).forEach(([key, item]) => {
                if (Array.isArray(queryFilter[key])) queryFilter[key] = item.join(',')
            })
            onSubmit(queryFilter)
            onCloseHandler()
        })
    }

    const countFilterLength = (filter) => {
        let totalLength = 0
        for (const key in filter) {
            if (filter.hasOwnProperty(key)) {
                if (Array.isArray(filter[key])) {
                    totalLength += filter[key].length
                } else {
                    totalLength += 1
                }
            }
        }
        setFilterCount(totalLength)
    }

    const onClearFilter = () => {
        setFilter(deepClone(INITIAL_FILTER))
        setErrorFilter({})
    }

    const props = {
        show: show,
        onShow: () => setShow(true),
        onClose: onCloseHandler,
        queryParams: QUERY_PARAMS,
        filterList: INITIAL_DATA_FILTER,
        activeFilter,
        onSelectFilter,
        filter,
        filterCount,
        options,
        onChangeOption,
        onSubmitFilter,
        onClearFilter,
        errorFilter,
    }

    return <Filter {...props} />
}
